import axiosInstance from '@/utils/axiosInstance';
import { showAlert } from '../components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

export const UploadProductFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosInstance.post(
      '/SmartProAPI/api/bts-products/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'File uploaded successfully');
    return res;
  } catch (error) {
    console.log('err', error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const downloadBtsProductsFile = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/bts-products/download',
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bts-products.csv'); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const createSchoolProposal = async (formData) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/school-proposals',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'School created successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};
export const createSchoolProposalInfo = async (formData) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/school-proposals/school-info',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'School Info created successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};
export const updateSchoolProposal = async (formData, id) => {
  try {
    const res = await axiosInstance.put(
      '/SmartProAPI/api/school-proposals/' + id,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Proposal updated successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};
export const updateSchoolProposalInfo = async (formData, id) => {
  try {
    const res = await axiosInstance.put(
      '/SmartProAPI/api/school-proposals/' + id + '/school-info',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Proposal updated successfully');
    return res.data;
  } catch (error) {
    console.error(error);
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getSalesReps = async () => {
  try {
    const res = await axiosInstance.get(
      '/SmartProAPI/api/school-proposals/sales-reps',
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getBtsProducts = async (searchTerm) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/bts-products/search?searchTerm=${searchTerm}`,
    );
    if (res.status === 404) {
      res.data = ['No data found'];
      showAlert('info', 'No products found');
    } else if (res.status !== 200) {
      handleApiError(
        'error',
        'Failed to fetch products',
        res.status,
      );
      throw new Error('Failed to fetch products');
    } else {
      return res.data;
    }
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getBtsProductsByClass = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products?classId=${classId}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const addManualProduct = async (schoolProposalId, classId, product, customMessage) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/manual?classId=${classId}`,
      product,
    );
    const isHeader = !!product.headerType;
    if (customMessage !== 'NO_ALERT') {
      showAlert('success', customMessage || `${isHeader ? 'Header' : 'Product'} added successfully`);
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const uploadProductFileByClass = async (
  file,
  schoolProposalId,
  classId,
) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/upload?classId=${classId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Products uploaded successfully');
    // Fetch updated products after upload
    return res.data;
  } catch (error) {
    // handleApiError('error', error?.response?.data?.message || error?.response?.status);
    console.log(error);
    throw error;
  }
};

export const uploadSchoolProposalCsvFile = async (
  file,
  schoolProposalId,
) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/upload-proposal`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Proposal CSV uploaded successfully');
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateManualProduct = async (
  schoolProposalId,
  classId,
  product,
  customMessage,
) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/${product.id}?classId=${classId}`,
      product,
    );
    const isHeader = !!product.headerType;
    if (customMessage !== 'NO_ALERT') {
      showAlert('success', customMessage || `${isHeader ? 'Header' : 'Product'} updated successfully`);
    }
    // Fetch updated products after updating
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteClassProduct = async (
  schoolProposalId,
  classId,
  productId,
  isHeader,
) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/${productId}?classId=${classId}`,
    );
    showAlert('success', `${isHeader ? 'Header' : 'Product'} deleted successfully`);
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const updateProposalStatus = async (id, status) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/school-proposals/${id}/status?status=${status}`,
    );
    showAlert('success', 'Status updated successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getSchoolProposals = async (
  page,
  size,
  search = '',
  sortBy = '',
  sortDir = 'desc',
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortBy}&sortDir=${sortDir}`,
    );
    if (res.status === 204) {
      return ['No Data Found'];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteSchoolProposal = async (id) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${id}`,
    );
    showAlert('success', 'Proposal deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportBTSExcel = async (schoolProposalId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-proposal`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bts-export-report.xlsx'); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const deleteMultipleProductByClass = async (
  schoolProposalId,
  classId,
  productIds,
) => {
  try {
    const res = await axiosInstance.delete(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products?classId=${classId}`,
      { data: productIds }, // send as raw array
    );
    showAlert('success', 'Products deleted successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportParentsInstruction = async (schoolProposalId, classId, schoolName = 'School', className = 'Class') => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-parents-instruction?classId=${classId}`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    const safeSchoolName = schoolName.replace(/[\\/:*?"<>|]/g, '_');
    const safeClassName = className.replace(/[\\/:*?"<>|]/g, '_');
    link.setAttribute('download', `${safeSchoolName} – ${safeClassName}.docx`); // Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportPdf = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-booklist-pdf?classId=${classId}`,
      {
        responseType: 'blob', // Important for file download
      },
    );
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'application/pdf' }),
    );
    window.open(url, '_blank');
  } catch (error) {
    console.log(error);
    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportBtsShReport = async (schoolProposalId, schoolName) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-bts-sh-report`,
      {
        responseType: 'blob',
      },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }

    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-1 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-1 report downloaded successfully');
  } catch (error) {
    console.error(error);

    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const kitImportTemplateReport = async (schoolProposalId, schoolName) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/kit-import-template-report`,
      {
        responseType: 'blob',
      },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }

    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-3 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-3 report downloaded successfully');
  } catch (error) {
    console.error(error);

    handleApiError(
      'error',
      error?.response?.data?.message || error.data,
      error?.response?.status,
    );
    throw error;
  }
};

export const getClassListForProposal = async (schoolProposalId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/class-list`,
    );
    if (res.status === 204) {
      return [];
    }
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const saveCategoryCode = async (schoolProposalId, data, schoolName) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/bts-step2-report`,
      data,
      {
        responseType: 'blob',
      },
    );
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'text/csv;charset=utf-8;' }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `step-2 ${schoolName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert('success', 'Step-2 report downloaded successfully');
    // return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const exportContractExportReport = async (
  schoolProposalId,
  schoolName,
) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/products/export-pronto-price-contract`,
      { responseType: 'blob' },
    );
    if (res.status === 204) {
      showAlert('warn', 'No products associated with this proposal');
      return;
    }
    let fileName = `contract-report-${schoolName}.csv`;
    let alertType = 'success';
    let alertMsg = 'Contract report downloaded successfully';
    if (res.status === 409) {
      fileName = `contract-report-409(error)-${schoolName}.csv`;
      alertType = 'warn';
      alertMsg = 'Contract report downloaded with warnings (409)';
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    showAlert(alertType, alertMsg);
  } catch (error) {
    // If error is 409, try to download file from error.response.data
    if (error?.response?.status === 409 && error?.response?.data) {
      const url = window.URL.createObjectURL(new Blob([error.response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `contract-report-409(error)-${schoolName}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      showAlert('warn', 'Contract report downloaded with warnings (409)');
    } else {
      console.log(error);
    }
  }
};
export const getProductSyncRequests = async (proposalId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/product-sync-requests/${proposalId}`,
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const getProductSyncRequestsBatch = async (proposalIds) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/product-sync-requests/batch-fetch',
      proposalIds
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const bulkActionProductSyncRequest = async (payload) => {
  try {
    const res = await axiosInstance.post(
      '/SmartProAPI/api/product-sync-requests/action/bulk',
      payload
    );
    showAlert('success', 'Changes updated successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const shareQuoteId = async (id, emails = []) => {
  try {
    const res = await axiosInstance.post(
      `/SmartProAPI/api/school-proposals/${id}/share-quote`,
      emails,
    );
    showAlert('success', 'Quote Shared successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const updateSchoolActiveStatus = async (quoteId, schoolIsActive) => {
  try {
    const res = await axiosInstance.post(`/SmartProAPI/api/school-proposals/quote/${quoteId}/active-status?school_is_active=${schoolIsActive}`);
    showAlert('success', `Proposal ${schoolIsActive ? 'Enabled' : 'Disabled'} successfully`);
    return res.data;
  } catch (error) {
    handleApiError(
      
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

export const updateClassStudentCount = async (
  schoolProposalId,
  classId,
  count,
) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/classes/${classId}/student-count?count=${count}`,
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    // throw error;
  }
};

export const getNotesParentsBts = async (schoolProposalId, classId) => {
  const res = await axiosInstance.get(
    `/SmartProAPI/api/school-proposals/${schoolProposalId}/class/${classId}/notes`
  );
  return res.data;
};

export const saveNotesParentsBts = async (schoolProposalId, classId, payload) => {
  const res = await axiosInstance.put(
    `/SmartProAPI/api/school-proposals/${schoolProposalId}/class/${classId}/notes`,
    payload
  );
  return res.data;
};

export const deleteNotesParentsBts = async (schoolProposalId, classId, noteType) => {
  const res = await axiosInstance.delete(
    `/SmartProAPI/api/school-proposals/${schoolProposalId}/class/${classId}/notes/${noteType}`
  );
  return res.data;
};

export const uploadBtsManualPdfAPI = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axiosInstance.post(
      '/SmartProAPI/api/bts-manual/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    showAlert('success', 'Manual PDF uploaded successfully');
    return res.data;
  } catch (error) {
    handleApiError('error', error?.response?.data?.message, error?.response?.status);
    throw error;
  }
};

export const getCurrentBtsManualPdfAPI = async () => {
  try {
    const res = await axiosInstance.get('/SmartProAPI/api/bts-manual/current');
    if (res.status === 204 || res.status === 200 && !res.data) {
      return null;
    }
    return res.data;
  } catch (error) {
    if (error?.response?.status !== 204) {
      handleApiError('error', error?.response?.data?.message, error?.response?.status);
    }
    return null;
  }
};

export const getUnreadSummary = async ({ limit = 10, search, lastSchool, firstSchool, filter } = {}) => {
  try {
    const params = new URLSearchParams();
    if (limit) params.set('limit', limit);
    if (search) params.set('search', search);
    if (lastSchool) params.set('lastSchool', lastSchool);
    if (firstSchool) params.set('firstSchool', firstSchool);

    const endpoint = filter === 'unread' ? 'unread-summary' : 'recent-chats';
    const response = await axiosInstance.get(`/SmartProAPI/api/classes/${endpoint}?${params.toString()}`);
    return response.data;
  } catch (error) {
    handleApiError('error', error?.response?.data?.message, error?.response?.status);
    throw error;
  }
};

export const getClassDivisions = async (schoolProposalId, classId) => {
  try {
    const res = await axiosInstance.get(
      `/SmartProAPI/api/school-proposals/${schoolProposalId}/classes/${classId}/divisions`
    );
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status
    );
    throw error;
  }
};


